module.exports = __webpack_public_path__ + "assets/img/0219.97c14aa5.png";